import { useEffect } from 'react'
// import { logout } from '../api/auth' // Disabled in static auth mode

export function LogoutPage() {
  useEffect(() => {
    ;(async () => {
      try {
        // Clear static session if present
        localStorage.removeItem('capexia.static_auth')
      } catch (_) {}
      location.assign('/login')
    })()
  }, [])
  return <div className="p-6">Signing out…</div>
}
